/* eslint-disable func-names */
// LIBRARY
import React from 'react';
import {
	Input as AntInput,
	Form as AntForm,
	Button as AntButton,
	List as AntList,
	Spin as AntSpin,
	Checkbox as AntCheckbox,
	Switch as AntSwitch,
	Alert as AntAlert,
	Col as AntCol,
	Row as AntRow,
	message as antdMessage
} from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroller';

// CUSTOM MODULES
import { UserAccessContext } from 'context/userAccess';
import HttpCodeMessage from 'shared_components/message_http_status';
import { showMessage } from 'services/settings/message';
import { RegexInput, AlphaNumInput } from 'shared_components/pattern_input';
import { fetchExamRequestList } from 'services/shared/examRequest';
import showIntegrationCodeModal from 'shared_components/integration_code_modal';
import {
	createdPanelAPI,
	updatePanelListAPI,
	getPanelInfoAPI,
} from 'services/settings/panelExamRequesting';
import { messagePrompts, buttonLabels, fieldLabels, fieldRules } from '../settings';

// CSS
import './panel_form.css';
import { fetchSections, fetchSpecimens } from 'services/settings/examItem';

class PanelFormTemplate extends React.Component {
	// eslint-disable-next-line no-useless-constructor
	constructor(props) {
		super(props);
	}

	state = {
		examRequestData: [],
		selectedExamRequest: [],
		loading: false,
		examRequestValidation: false,
		chosenExamReq: 0,
	};

	componentDidMount() {
		// const userData = JSON.parse(sessionStorage.LOGGEDIN_USER_DATA);
		// const UserDatatype = userData.loginType
		// const jsonFormatAccessMatrix = JSON.parse(sessionStorage.ACCESS_MATRIX);
		// const settingsUpdateArray =  jsonFormatAccessMatrix.settings.update
		// if (settingsUpdateArray.some(data => data === UserDatatype))
		// {
		// 	this.setState({
		// 		buttonUpdateVisible:true
		// 	})
		// }
		this.getExamRequest();

		if (this.props.drawerButton === buttonLabels.update) {
			// Get selected examrequest in db for update
			if (this.props.panelInfo) {
				this.getSelectedExamRequest(this.props.panelInfo.panelRequestID);

				this.setState({ chosenExamReq: this.state.selectedExamRequest.length })
			}
		}
	}

	getExamRequest = async () => {
		// Get all exam request
		const examRequestListData = await fetchExamRequestList();
		if (!examRequestListData || examRequestListData.length === 0) {
			HttpCodeMessage({
				status: 404,
				message: messagePrompts.noExamFound,
			});
			return;
		}

		const sections = await fetchSections();
		const specimens = await fetchSpecimens();

		// Assign to state
		const examRequestData = [];
		// Filter for active exam requests
		const activeExamRequests = (examRequestListData || []).filter(item => item.examRequestActive === 1);

		activeExamRequests.forEach(function(valueExamRequest, indexExamRequest) {
			const sectionName = sections.filter(items => items.sectionID === valueExamRequest.sectionID)
			const specimenName = specimens.filter(items => items.specimenID === valueExamRequest.specimenID)

			examRequestData[indexExamRequest] = {
				key: valueExamRequest.examRequestID,
				title: valueExamRequest.examRequestName,
				sectionName: sectionName.length > 0 ? sectionName[0].sectionName : 'Unknown Section',
				specimenName: specimenName.length > 0 ? specimenName[0].specimenName : 'Unknown Specimen',
			};
		});

		//sort
		const examReqSort = [...examRequestData].sort((a, b) =>
			a.title.toUpperCase() > b.title.toUpperCase() ? 1 : -1,
	  	);
		this.setState({ examRequestData: examReqSort });
	};

	getSelectedExamRequest = async iKey => {
		let dataPanel = null;

		try {
			dataPanel = await getPanelInfoAPI(iKey);
		} catch (e) {
			showMessage('M0004');
			return;
		}

		const selectedExamRequest = [];

		// Check if dataPanel and its nested properties exist
		if (dataPanel && dataPanel.data && dataPanel.data.examRequests && Array.isArray(dataPanel.data.examRequests)) {
			dataPanel.data.examRequests.map(function(valueSelectedExamRequest) {
				selectedExamRequest.push(valueSelectedExamRequest.examRequestID);
				return selectedExamRequest;
			});
		}

		this.setState({ chosenExamReq: selectedExamRequest.length })
		this.setState({ selectedExamRequest });
	};

	transferFilterOption = (inputValue, option) => option.description.indexOf(inputValue) > -1;

	handleSelectedExams = selectedExamRequest => {
		console.log('checkbox selected', selectedExamRequest)
		this.setState({ selectedExamRequest: selectedExamRequest, chosenExamReq: selectedExamRequest.length });
	};

	onSubmit = values => {
		// this.props.form.validateFields( (err, values) => {
		// if(err){ // Form validation error
		// 	return;
		// }

		if (
			this.state.selectedExamRequest === undefined ||
			this.state.selectedExamRequest.length === 0
		) {
			this.setState({ examRequestValidation: true });
			showMessage('M0005');
			return;
		}

		// Duplicate validation
		const { panelList, drawerButton, panelInfo } = this.props;
		const { panel_name } = values;
		const isUpdate = drawerButton === buttonLabels.update;

		const isDuplicate = (panelList || []).some(item => {
			const existingName = (item.panel_name || "").toLowerCase().trim();
			const newName = (panel_name || "").toLowerCase().trim();

			if (isUpdate) {
				// For update, ignore current record
				return existingName === newName && item.panelRequestID !== panelInfo.panelRequestID;
			}
			return existingName === newName;
		});

		if (isDuplicate) {
			return antdMessage.info({
				content: messagePrompts.duplicatePanelName,
				duration: 3
			});
		}

		try {
			showIntegrationCodeModal(values.panel_integration_code, {
				currentItemId: values.panel_id,
				onConfirm: () => {
					this.setState({ loading: true });
					// eslint-disable-next-line no-unused-expressions
					this.props.drawerButton === buttonLabels.update
						? this.updatePanel(values)
						: this.createPanel(values);
				},
				onCancel: () => {
					// Do nothing, user stays on the form
				}
			});
		} catch (errCatch) {
			showMessage('M0004');
		}

		// });
	};

	createPanel = async fieldValues => {
		const payload = {
			panelRequestName: fieldValues.panel_name,
			panelRequestCode: fieldValues.panel_code,
			panelRequestIntegrationCode: fieldValues.panel_integration_code,
			panelRequestActive: fieldValues.panel_status ? 1 : 0,
			examRequests: this.state.selectedExamRequest.join(','),
			panelRequestSort: (this.props.maxSort || 0) + 1,
		};

		try {
			const response = await createdPanelAPI(payload);

			// @ts-ignore
			if (response.status === 200) {
				this.setState({ loading: false });
				showMessage('M0002');

				// Call onSuccess if provided, otherwise call onCancel
				if (this.props.onSuccess) {
					this.props.onSuccess();
				} else if (this.props.onCancel) {
					this.props.onCancel();
				}
			} else {
				this.setState({ loading: false });
				showMessage('M0004');
			}
		} catch (error) {
			this.setState({ loading: false });
			showMessage('M0004');
		}
	};

	updatePanel = async fieldValues => {
		const payload = {
			panelRequestID: fieldValues.panel_id,
			panelRequestName: fieldValues.panel_name,
			panelRequestCode: fieldValues.panel_code,
			panelRequestIntegrationCode: fieldValues.panel_integration_code,
			panelRequestActive: fieldValues.panel_status ? 1 : 0,
			examRequests: this.state.selectedExamRequest.join(','),
		};

		try {
			const response = await updatePanelListAPI(payload);

			// @ts-ignore
			if (response.status === 200) {
				this.setState({ loading: false });
				showMessage('M0003');

				// Call onSuccess if provided, otherwise call onCancel
				if (this.props.onSuccess) {
					this.props.onSuccess();
				} else if (this.props.onCancel) {
					this.props.onCancel();
				}
			} else {
				this.setState({ loading: false });
			}
		} catch (error) {
			this.setState({ loading: false });
			showMessage('M0004');
		}
	};

	handleInfiniteOnLoad = () => {
		const { data } = this.state;
		this.setState({
			loading: true,
		});
		if (data.length > 14) {
			this.setState({
				hasMore: false,
				loading: false,
			});
		}
	};

	render() {
		const { buttonUpdateVisible, chosenExamReq } = this.state;
		const { panelInfo, drawerButton } = this.props;

		return (
			<div>
				<AntForm layout="vertical" onFinish={this.onSubmit}>
					<section style={{ marginBottom: 50 }}>
						{
								this.props.drawerButton === buttonLabels.update ?
								(
									<AntForm.Item
										name="panel_status"
										label={fieldLabels.panel_status}
										valuePropName="checked"
										initialValue={panelInfo.status === 0 ? false : true}
									>
									<AntSwitch/>
									</AntForm.Item>
								) 
								:
								(
									<AntForm.Item
										name="panel_status"
										label={fieldLabels.panel_status}
										valuePropName="checked"
										initialValue={true}
									>
									<AntSwitch disabled={true} />
									</AntForm.Item>
								) 
								
							}
						<AntRow gutter={12}>
							<AntCol span={12}>
								<AntForm.Item
									name="panel_name"
									label={fieldLabels.panel_name}
									rules={fieldRules.panel_name}
									initialValue={panelInfo.panel_name}
								>
									<RegexInput regex={/[A-Za-z0-9 -]/} maxLength={254} />
								</AntForm.Item>
								<AntCol span={12}>
									<AntForm.Item
										hidden={true}
										name="panel_id"
										label={fieldLabels.panel_id}
										className={panelInfo ? null : 'hide'}
										initialValue={panelInfo.panelRequestID}
									>
										<AntInput disabled />
									</AntForm.Item>
								</AntCol>
							</AntCol>
						</AntRow>
						<AntRow gutter={12}>
							<AntCol span={12}>
								<AntForm.Item
									name="panel_code"
									label={fieldLabels.panel_code}
									rules={fieldRules.panel_code}
									initialValue={panelInfo.code}
								>
									<AlphaNumInput maxLength={50} />
									{/* {getFieldDecorator('panel_code', {
										initialValue: panelInfo.code,
										rules: fieldRules.panel_code,
									})(
										<AlphaNumInput maxLength={50} />
									)}	 */}
								</AntForm.Item>
							</AntCol>
							<AntCol span={12}>
								<AntForm.Item
									name="panel_integration_code"
									label={fieldLabels.panel_integration_code}
									rules={fieldRules.panel_integration_code}
									initialValue={panelInfo.integration_code}
								>
									<AntInput maxLength={50} />
									{/* {getFieldDecorator('panel_integration_code', {
										initialValue: panelInfo.integration_code,
										rules: fieldRules.panel_integration_code,
									})(
										<AntInput maxLength={50} />
									)}	 */}
								</AntForm.Item>
							</AntCol>
						</AntRow>
						<AntRow style={{ padding: '20px 0px' }}>
							<AntCol span={12}><span>EXAM REQUESTS</span></AntCol>
							<AntCol span={12}><span>SELECTED EXAM REQUESTS: {chosenExamReq}</span></AntCol>
						</AntRow>
						<AntRow className="panel-header">
							<AntCol span={8} className="panel-col-name"><span>EXAM REQUEST NAME</span></AntCol>
							<AntCol span={8}><span>SECTION</span></AntCol>
							<AntCol span={8}><span>SPECIMEN</span></AntCol>
						</AntRow>
						<AntForm.Item>
							{this.state.examRequestValidation ? (
								<AntAlert message="Please select exam request!" type="error" />
							) : null}
							<div className="panel-infinite-container">
								<InfiniteScroll
									initialLoad={false}
									loadMore={this.handleInfiniteOnLoad}
									pageStart={0}
									hasMore={!this.state.loading && this.state.hasMore}
									useWindow={false}
								>
									<AntCheckbox.Group
										onChange={this.handleSelectedExams}
										value={this.state.selectedExamRequest}
									>
										<AntList
											size="small"
											itemLayout="vertical"
											dataSource={this.state.examRequestData}
											renderItem={item => (
												<AntList.Item key={item.key} style={{ padding: 0 }}>
													<AntRow className="panel-row">
														<AntCol span={8}>
															<AntCheckbox value={item.key}>{item.title}</AntCheckbox>
														</AntCol>
														<AntCol span={8}>
															<div>{item.sectionName}</div>
														</AntCol>
														<AntCol span={8}>
															<div>{item.specimenName}</div>
														</AntCol>
													</AntRow>
												</AntList.Item>
											)}
										>
											{this.state.loading && this.state.hasMore && (
												<div className="panel-loading-container">
													<AntSpin />
												</div>
											)}
										</AntList>
									</AntCheckbox.Group>
								</InfiniteScroll>
							</div>
						</AntForm.Item>
					</section>
					<section className="drawerFooter">
						<div>
							<AntButton
								shape="round"
								style={{ marginRight: 10, width: 120 }}
								onClick={this.props.onCancel}
							>
								{buttonLabels.cancel}
							</AntButton>
							<UserAccessContext.Consumer>
								{value =>
									value.userAccess.settings.create && (
										<AntButton
											type="primary"
											shape="round"
											htmlType="submit"
											loading={this.state.loading}
											style={{ margin: 10, width: 120 }}
										>
											{drawerButton}
										</AntButton>
									)
								}
							</UserAccessContext.Consumer>
						</div>
					</section>
				</AntForm>
			</div>
		);
	}
}

PanelFormTemplate.propTypes = {
	panelInfo: PropTypes.object,
	drawerButton: PropTypes.string.isRequired,
	onCancel: PropTypes.func,
	onSuccess: PropTypes.func,
};

PanelFormTemplate.defaultProps = {
	panelInfo: null,
	onCancel() {
		return null;
	},
	onSuccess() {
		return null;
	},
};

export default withRouter(PanelFormTemplate);
